export { default } from './Page.container'



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/components/Page/index.js